"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZEditor = exports.ZEditorTools = void 0;
const React = __importStar(require("react"));
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const kendo_react_editor_1 = require("@progress/kendo-react-editor");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const kendo_react_intl_1 = require("@progress/kendo-react-intl"); //spellcheck-off
const kendo_editor_common_1 = require("@progress/kendo-editor-common");
const libphonenumber_js_1 = require("libphonenumber-js");
const ZEditorUtils_1 = require("./ZEditorUtils");
const ll_1 = require("../../languages/ll");
const variableNodes_1 = require("./variableNodes");
const styled_components_1 = __importDefault(require("styled-components"));
const PhoneNumberToolComponent = (props) => {
    const { view } = props, { languageId } = React.useContext(ll_1.llContext);
    let phoneNumber;
    const onClick = () => {
        phoneNumber &&
            kendo_react_editor_1.EditorUtils.applyLink(view, {
                mark: "link",
                attrs: { href: `tel:${phoneNumber.number}` }
            });
    };
    if (view) {
        let selection = view.domObserver.currentSelection;
        if (selection.anchorNode &&
            selection.focusNode &&
            selection.anchorNode == selection.focusNode) {
            let text = selection.anchorNode.nodeValue;
            if (text) {
                let selectionStart = Math.min(selection.focusOffset, selection.anchorOffset);
                let selectionEnd = Math.max(selection.focusOffset, selection.anchorOffset);
                let selectedText = text.substring(selectionStart, selectionEnd);
                phoneNumber = libphonenumber_js_1.parsePhoneNumberFromString(selectedText, "US");
            }
        }
    }
    return (React.createElement(kendo_react_buttons_1.Button, { title: ll_1.ll({ key: "PhoneNumberLinkTooltip", languageId }), disabled: phoneNumber ? false : true, onClick: onClick, className: "k-button-icon" },
        React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: `${props.className} k-icon`, icon: "phone" })));
};
const PhoneNumberTool = styled_components_1.default(PhoneNumberToolComponent) `
   height: 20px !important;
`;
const BoldTool = (props) => {
    const customBoldSettings = kendo_react_editor_1.EditorToolsSettings.bold;
    const { languageId } = React.useContext(ll_1.llContext);
    customBoldSettings.props.title = ll_1.ll({
        key: "Bold",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createInlineFormatTool(customBoldSettings);
    return React.createElement(Tool, Object.assign({}, props));
};
const ItalicTool = (props) => {
    const customItalicSettings = kendo_react_editor_1.EditorToolsSettings.italic;
    const { languageId } = React.useContext(ll_1.llContext);
    customItalicSettings.props.title = ll_1.ll({
        key: "Italic",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createInlineFormatTool(customItalicSettings);
    return React.createElement(Tool, Object.assign({}, props));
};
const UnderlineTool = (props) => {
    const customUnderlineSettings = kendo_react_editor_1.EditorToolsSettings.underline;
    const { languageId } = React.useContext(ll_1.llContext);
    customUnderlineSettings.props.title = ll_1.ll({
        key: "Underline",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createInlineFormatTool(customUnderlineSettings);
    return React.createElement(Tool, Object.assign({}, props));
};
const OrderedListTool = (props) => {
    const customOrderedListProps = kendo_react_editor_1.EditorToolsSettings.orderedList;
    const { languageId } = React.useContext(ll_1.llContext);
    customOrderedListProps.props.title = ll_1.ll({
        key: "InsertOrderedList",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createListTool(customOrderedListProps);
    return React.createElement(Tool, Object.assign({}, props));
};
const UnorderedListTool = (props) => {
    const customUnorderedListProps = kendo_react_editor_1.EditorToolsSettings.bulletList;
    const { languageId } = React.useContext(ll_1.llContext);
    customUnorderedListProps.props.title = ll_1.ll({
        key: "InsertUnorderedList",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createListTool(customUnorderedListProps);
    return React.createElement(Tool, Object.assign({}, props));
};
const LinkTool = (props) => {
    const customLinkProps = kendo_react_editor_1.EditorToolsSettings.link;
    const { languageId } = React.useContext(ll_1.llContext);
    customLinkProps.props.title = ll_1.ll({
        key: "InsertHyperlink",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createLinkTool(customLinkProps);
    return React.createElement(Tool, Object.assign({}, props));
};
const UnlinkTool = (props) => {
    const customUnlinkProps = kendo_react_editor_1.EditorToolsSettings.unlink;
    const { languageId } = React.useContext(ll_1.llContext);
    customUnlinkProps.props.title = ll_1.ll({
        key: "RemoveLink",
        languageId
    });
    const Tool = kendo_react_editor_1.EditorTools.createUnlinkTool(customUnlinkProps);
    return React.createElement(Tool, Object.assign({}, props));
};
exports.ZEditorTools = {
    boldTool: BoldTool,
    italicTool: ItalicTool,
    underlineTool: UnderlineTool,
    orderedListTool: OrderedListTool,
    unorderedListTool: UnorderedListTool,
    linkTool: LinkTool,
    phoneNumberTool: PhoneNumberTool,
    unlinkTool: UnlinkTool
};
const onMount = value => event => {
    const { viewProps } = event;
    const defaultSchema = event.viewProps.state.schema;
    const variableSchema = new kendo_react_editor_1.ProseMirror.Schema({
        nodes: defaultSchema.spec.nodes.addBefore("div", variableNodes_1.variableNodeName, variableNodes_1.variableNodeSpec),
        marks: defaultSchema.spec.marks
    });
    const plugins = [...viewProps.state.plugins];
    // Create a new document using the schema.
    const doc = kendo_react_editor_1.EditorUtils.createDocument(variableSchema, value || "");
    // Return the custom EditorView object that will be used by Editor.
    return new kendo_react_editor_1.ProseMirror.EditorView({ mount: event.dom }, {
        ...event.viewProps,
        nodeViews: {
            variable: variableNodes_1.variableNodeView
        },
        state: kendo_react_editor_1.ProseMirror.EditorState.create({
            schema: variableSchema,
            doc,
            plugins
        }),
        handleClickOn: (view, pos, node, nodePos, event, direct) => {
            if (event.target.classList.contains("k-i-close")) {
                return true; // we handle this in the variable node code, so tell ProseMirror it shouldn't try to
            }
            return false; // let ProseMirror handle all other events
        }
    });
};
const onExecute = value => event => {
    let { transaction, state } = event;
    const { schema } = state;
    if (transaction.selectionSet &&
        !(transaction.selection instanceof kendo_editor_common_1.NodeSelection)) {
        transaction.doc.descendants((d, pos) => {
            if (d.type.name === variableNodes_1.variableNodeName) {
                const json = d.toJSON();
                const selectedAttributeIsTrue = json.attrs.selected === "true";
                if (ZEditorUtils_1.selectionContainsPosition(transaction.selection, pos)) {
                    if (!selectedAttributeIsTrue) {
                        transaction = ZEditorUtils_1.selectNode({
                            transaction,
                            schema,
                            json,
                            pos
                        });
                    }
                }
                else {
                    if (selectedAttributeIsTrue) {
                        transaction = ZEditorUtils_1.deselectNode({
                            transaction,
                            schema,
                            json,
                            pos
                        });
                    }
                }
            }
        });
    }
};
function loadMessagesForLanguage(languageId) {
    kendo_react_intl_1.loadMessages({
        editor: {
            "hyperlink-dialog-content-address": ll_1.ll({
                key: "WebAddress",
                languageId
            }),
            "hyperlink-dialog-cancel": ll_1.ll({
                key: "Cancel",
                languageId
            }),
            "hyperlink-dialog-title": ll_1.ll({
                key: "InsertHyperlink",
                languageId
            }),
            "hyperlink-dialog-insert": ll_1.ll({
                key: "Insert",
                languageId
            }),
            "hyperlink-dialog-content-newwindow": ll_1.ll({
                key: "OpenLinkInNewWindow",
                languageId
            }),
            "hyperlink-dialog-content-title": ll_1.ll({
                key: "EditorLinkDialogTitle",
                languageId
            })
        }
    }, languageId);
}
const ZEditorComponent = (props) => {
    const { languageId } = React.useContext(ll_1.llContext), editor = React.createRef();
    loadMessagesForLanguage(languageId);
    const { className, id, value, tools, ...editorProps } = props;
    return (React.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId },
        React.createElement("div", { className: className, id: id },
            React.createElement(kendo_react_editor_1.Editor, Object.assign({ ref: editor, tools: tools || [
                    [BoldTool, ItalicTool, UnderlineTool],
                    [OrderedListTool, UnorderedListTool],
                    [LinkTool, PhoneNumberTool, UnlinkTool],
                    [...(props.additionalTools || [])]
                ], value: value, defaultEditMode: "div", onMount: onMount(value), onExecute: onExecute(value) }, editorProps)))));
};
exports.ZEditor = styled_components_1.default(ZEditorComponent) `
   & .k-editor-content > .ProseMirror {
      font-family: ${props => props.theme["font-family"]};
      padding: 0px 15px;
   }
   & .k-dropdown .k-dropdown-wrap {
      margin: 0px 3px;
   }

   & v.variable-bubble {
      background: #e0e0e0;
      border-radius: 20px;
      padding: 4px 10px;
      & .k-select {
         display: inline-block;
      }
      & .k-i-close {
         margin: 0px 0px 2px 6px;
         padding: 0px;
         text-decoration: none !important;
      }
      &:hover,
      &.ProseMirror-selectednode,
      &[selected="true"] {
         background: rgba(0, 0, 0, 0.3);
         color: white;
      }
   }
`;
//# sourceMappingURL=ZEditor.js.map